// extracted by mini-css-extract-plugin
export default {"tableHeader":"T232sviSdwYM8hgIvKij"};